import { ENVIRONMENT } from "../_Environment.js";
import { LAYOUTS } from "../_Layouts.js";

export const APP_ENVIRONMENT = Object.freeze({
    ...ENVIRONMENT,

    APP__MODE_THEME_DARK: "dark", APP__MODE_THEME_LIGHT: "light",

    RUNTIME: {
        ENVIRONMENT: ENVIRONMENT.MODE_ENVIRONMENT,
        IS_DEVELOPMENT: ENVIRONMENT.IS_PROD !== true,
    },

    BACKEND: {
        HAS_CONNECT: Boolean(ENVIRONMENT.BACKEND?.URL),
        CONNECTION_TYPE: ENVIRONMENT.MODE_ENVIRONMENT,
        API_PORT: ENVIRONMENT.BACKEND?.PORT ?? null,
        API_VERSION: ENVIRONMENT.BACKEND?.VERSION ?? 1,
        URLS: {
            ENDPOINT: ENVIRONMENT.BACKEND?.URL || "",
            SOCKET: ENVIRONMENT.SOCKET?.URL || "",
            STATIC: ENVIRONMENT.STATIC?.URL || "",
            DOCUMENTATION: ENVIRONMENT.DOCS?.URL || "",
        },
    },

    AUTH: {
        LOGOUT_ON_401: LAYOUTS.IS_USER_AUTH_AUTO_LOGOUT_ON_EXPIRE === true,
        PERSIST_SESSION: LAYOUTS.IS_USER_AUTH_SESSION_PERSISTENT_DEFAULT === true,
    },

    TEMPLATES: {
        LAYOUT_STRUCTURE_PUBLIC: LAYOUTS.LAYOUT_PUBLIC?.APPEARANCE_GLOBAL?.LAYOUT_LEVEL ?? 1,
        LAYOUT_STRUCTURE_PRIVATE: LAYOUTS.LAYOUT_PRIVATE?.APPEARANCE_GLOBAL?.LAYOUT_LEVEL ?? 1,
        THEME_MODE: LAYOUTS.IS_MODE_DARK === true ? "dark" : "light",
    },

    UTILITIES: { MODE_LIGHT_MODE_DARK: true },
    FEEDBACK: { TOAST: { DEFAULT_POSITION: "top-center", DEFAULT_DURATION_MS: 3500 } },

    DATA: {
        ENDPOINTS: { HOME_CONTENT: "", HOME_STATUS: "" },
        FALLBACK_STRATEGY: "NONE", SEED_ONLY_WHEN_SERVER_OK: true,
        CONTENT: { BLOG: false, PROJECT: false },
        SEED: {},
    },
});
